import React from "react";

function DashHeader() {
  return (
    <div className="dash-pic p-[4.59rem] mt-[1.5rem] rounded-[10px] text-white">
      <div className="text-[0.875rem] font-appleAlt font-[400] ">Welcome</div>
      <div className="py-[.94rem] text-[2rem] font-[700] font-appleAlt">
        WATER REGULATION INFORMATION SYSTEM (WARIS)
      </div>
      <div className="text-[1.125rem] font-[500] font-appleAlt lg:max-w-[860px] w-full">
        NAWASCCO Software application designed for database management, aiding
        in the input, consolidation, and analysis of data from Water Utilities
        to produce performance reports for the water sector.
      </div>
    </div>
  );
}

export default DashHeader;
